module.exports = __webpack_public_path__ + "static/media/calendar.54229fd8.svg";